<template>
  <div>
    <alert
      type="warning"
      v-if="alertStatus.isVisible"
    >
      <div class="alert-icon">
        <i class="now-ui-icons ui-1_bell-53"></i>
      </div>
      <span>{{ alertStatus.message }}</span>
    </alert>

    <!-- section below is active if the browser is mobile and on the home page height:100vh : :class="[{ 'alert-home-mobile': isHome && isMobile }]"-->
    <section
      class="parallax-section"
      data-scrollax-parent="true"
      id="home-section"
      :class="[{ 'full-background': isHome && isWebView }]"
    >
      <parallax
        class="bg par-elem"
        v-bind:style="{
          'background-image':
            'url(' +
            myTheme.home_section_background_image +
            ')',
        }"
      ></parallax>
      <div class="overlay"></div>
      <div class="container">
        <div class="section-title center-align">
          <el-image
            lazy
            :src="myTheme.home_section_logo_image"
            class="image-home-logo"
          >
            <div slot="error" class="image-slot">
              <img class="photo" src="img/logo-error-500.png" />
            </div>
          </el-image>
        </div>
        <DeliveryPickupMenu
          :small="false"
          :isHome="true"
          v-if="currentPage == 'home' && locations.length > 0"
        />
        <order-changes-confirmation
          ref="popupConfirmation"
        ></order-changes-confirmation>
        <details-buttons
          v-if="selectedLocation && selectedLocation.id"
        ></details-buttons>
        <AllergyPopUp v-if="selectedLocation && !isHome" />
      </div>
    </section>
  </div>
</template>
<script>
import { Parallax, Button, Alert } from "@/components";
import { DeliveryPickupMenu, OrderChangesConfirmation } from "@/layout";
import DetailsButtons from "./DetailsButtons";
import AllergyPopUp from "./AllergyPopUp";
import { isEmpty } from "lodash";
import { ORDER_TYPE } from "@/utilities/enums";
import { canMakeOrder } from "@/utilities/helper";
import { isMobile } from "mobile-device-detect";
export default {
  name: "home-section",
  components: {
    DeliveryPickupMenu,
    DetailsButtons,
    [Button.name]: Button,
    Alert,
    Parallax,
    OrderChangesConfirmation,
    AllergyPopUp
  },
  props: {
    currentPage: String,
    isWebView: Boolean,
  },
  data() {
    return {
      selectedType: null,
      isMounted: false,
      deliveryStatus: null,
      isMobile: isMobile,
      largeImg: false,
    };
  },
  computed: {
    multiLocations: function() {
      //!multiLocations &&  check in the template
      return this.locations.length > 1;
    },
    locationStatus: function() {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    },
    alertStatus() {
      if (!this.isMounted) return { isVisible: false };
      if (this.multiLocations && this.isHome) {
        let deliveryClosed = this.allLocationsClosed(
          ORDER_TYPE.Delivery.id
        );
        let collectionClosed = this.allLocationsClosed(
          ORDER_TYPE.Collection.id
        );
        let tableClosed = this.allLocationsClosed(ORDER_TYPE.Table.id);

        //--- all locations are closed
        if (deliveryClosed && collectionClosed && tableClosed) {
          return {
            isVisible: true,
            message: this.$t('message.sorry_currently_closed'),
          };
        }

        if (this.newCart.orderType == ORDER_TYPE.Delivery.id) {
          let message = "";
          let isVisible = false;
          if (deliveryClosed) {
            // no location is open or offer pre-order
            message = this.$t('message.closed_for_delivery');
            isVisible = true;
            //--- check if any location is open for collection
            if (
              this.checkIfAnyLocationIsOpenByType(
                ORDER_TYPE.Collection.id
              )
            ) {
              message += this.$t('message.accepting_orders_for_collection');
            } else if (
              this.checkIdAnyLocationHasPreOrderByType(
                ORDER_TYPE.Collection.id
              )
            ) {
              message += this.$t('message.accepting_preorder_for_collection');
            } else if (!tableClosed) {
              message += this.$t('message.accepting_table_ordering');
            }
          } else if (
            !this.checkIfAnyLocationIsOpenByType(ORDER_TYPE.Delivery.id)
          ) {
            //-- no location is open => some locations offer pre-order
            isVisible = true;
            message = this.$t('message.closing_delivery_accept_preorde_delivery');
          }
          return {
            isVisible: isVisible,
            message: message,
          };
        } else if (this.newCart.orderType == ORDER_TYPE.Collection.id) {
          //--- check if any location is open for delivery
          let message = "";
          let isVisible = false;
          if (collectionClosed) {
            // no location is open or offer pre-order
            message = this.$t('message.closed_for_collection');
            isVisible = true;
            //--- check if any location is open for collection or tableOrdering
            if (
              this.checkIfAnyLocationIsOpenByType(ORDER_TYPE.Delivery.id)
            ) {
              message += this.$t('message.accepting_orders_for_delivery');
            } else if (
              this.checkIdAnyLocationHasPreOrderByType(
                ORDER_TYPE.Delivery.id
              )
            ) {
              message += this.$t('message.accepting_preorder_for_delivery');
            } else if (!tableClosed) {
              message += this.$t('message.accepting_table_ordering');
            }
          } else if (
            !this.checkIfAnyLocationIsOpenByType(
              ORDER_TYPE.Collection.id
            )
          ) {
            //-- no location is open => some locations offer pre-order
            isVisible = true;
            message += this.$t('message.closing_collection_accept_preorde_collection');
          }
          return {
            isVisible: isVisible,
            message: message,
          };
        } else if ( this.newCart.orderType == ORDER_TYPE.Table.id && tableClosed ) {
          let message = this.$t('message.closed_for_table_ordering');
          let deliveryOpen = this.checkIfAnyLocationIsOpenByType(ORDER_TYPE.Delivery.id);
          let collectionOpen = this.checkIfAnyLocationIsOpenByType(ORDER_TYPE.Collection.id)
          if(!deliveryOpen && !collectionOpen){
            let deliveryPreOrder = this.checkIdAnyLocationHasPreOrderByType(ORDER_TYPE.Delivery.id);
            let collectionPreOrder = this.checkIdAnyLocationHasPreOrderByType(ORDER_TYPE.Collection.id)
            message+= this.$t('message.accepting_preorder_for');
            if(deliveryPreOrder){message+=this.$t('message.delivery')}
            if(deliveryPreOrder && collectionPreOrder) {message+=this.$t('message.and')}
            if(collectionPreOrder){message+= this.$t('message.collection') }

          }else{
            message+= this.$t('message.accepting_order_for');
            if(deliveryOpen){message+=this.$t('message.delivery')}
            if(deliveryOpen && collectionOpen) {message+=this.$t('message.and')}
            if(collectionOpen){message+=this.$t('message.collection')}
          }

          return {
            isVisible: true,
            message: message
          };
        }

        return {
          isVisible: false,
        };
      } else {
        const {
          selectedLocation
        } = this;

        if (isEmpty(selectedLocation)) {
          return { isVisible: false };
        }

        const {
          can_make_order,
          accepts_future_orders,
          can_accept_delivery,
          can_accept_collection,
        } = this.locationStatus;
        let message = this.$t('message.sorry_currently_closed');
        if (this.selectedLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {
                paused_to: this.selectedLocation.paused_to,
              });
          return {
            isVisible: true,
            message,
          };
        }
        if (can_make_order) {
          if (
            this.selectedLocation.openingHours.sitIn ||
            this.selectedLocation.openingHours.delivery ||
            this.selectedLocation.openingHours.collection
          ) {
            return {
              isVisible: false,
            };
          }

          if (accepts_future_orders) {
            if (
              !this.selectedLocation.openingHours.delivery &&
              can_accept_delivery &&
              !this.selectedLocation.openingHours.collection &&
              can_accept_collection
            ) {
              return {
                message: this.$t('message.accept_preorder_for_delivery_collection'),
                isVisible: true,
              };
            }

            if (
              !this.selectedLocation.openingHours.delivery &&
              !this.selectedLocation.openingHours.collection
            ) {
              if (can_accept_delivery) {
                return {
                  message: this.$t('message.accept_preorder_for_delivery'),
                  isVisible: true,
                };
              }
              if (can_accept_collection) {
                return {
                  message: this.$t('message.accept_preorder_for_collection'),
                  isVisible: true,
                };
              }
            }
            return {
              isVisible: false,
            };
          } else {
            return {
              isVisible: false,
            };
          }
        } else {
          return {
            isVisible: true,
            message,
          };
        }
      }
    },
    isHome() {
      return this.currentPage == "home";
    },
  },
  methods: {
    allLocationsClosed(type) {
      let res = this.locations.filter((location) => {
        let current_location_status = canMakeOrder(location, true);
        return (
          (type == ORDER_TYPE.Delivery.id &&
            (location.openingHours.delivery ||
              current_location_status.can_accept_delivery)) ||
          (type == ORDER_TYPE.Collection.id &&
            (location.openingHours.collection ||
              current_location_status.can_accept_collection)) ||
          (type == ORDER_TYPE.Table.id &&
            location.openingHours.sitIn &&
            current_location_status.can_accept_tableOrdering)
        );
      });
      return res.length <= 0;
    },
    checkIfAnyLocationIsOpenByType(type) {
      let res = this.locations.find((location) => {
        let current_location_status = canMakeOrder(location, true);
        return (
          (type == ORDER_TYPE.Delivery.id &&
            location.openingHours.delivery &&
              current_location_status.can_accept_delivery) ||
          (type == ORDER_TYPE.Collection.id &&
            location.openingHours.collection &&
              current_location_status.can_accept_collection) ||
          (type == ORDER_TYPE.Table.id &&
            location.openingHours.sitIn &&
            current_location_status.can_accept_tableOrdering)
        );
      });
      return !!res;
    },
    checkIdAnyLocationHasPreOrderByType(type) {
      let res = this.locations.find((location) => {
        let current_location_status = canMakeOrder(location, true);
        return (
          (type == ORDER_TYPE.Delivery.id &&
            !location.openingHours.delivery &&
              current_location_status.can_accept_delivery) ||
          (type == ORDER_TYPE.Collection.id &&
            !location.openingHours.collection &&
              current_location_status.can_accept_collection)
        );
      });
      return !!res;
    },

    /*async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }
        navigator.geolocation.getCurrentPosition(
          pos => {
            resolve(pos);
          },
          err => {
            reject(err);
          }
        );
      });
    },*/
    openPopUpConfirmationEventListner: function() {
      this.$root.$off("OPEN_POPUP_CONFIRMATION");
      this.$root.$on("OPEN_POPUP_CONFIRMATION", (data) => {
        this.$refs.popupConfirmation.ItemsNotAvailable = data.ItemsNotAvailable;
        this.$refs.popupConfirmation.ItemsWithDiffPrice =
          data.ItemsWithDiffPrice;
        this.$refs.popupConfirmation.shown = true;
        this.$refs.popupConfirmation.newOrderType = data.NewOrderType;
        this.$refs.popupConfirmation.oldOrderType = data.OldOrderType;
      });
    },
    bigImage() {
      if (this.currentPage == "home" && this.isMobile === true) {
        // if current page is home and is mobile make image big
        this.largeImg = true;
      } else {
        this.largeImg = false;
      }
    },
  },
  mounted() {
    this.isMounted = true;
    this.bigImage();
  },
  created: function() {
    if (this.isHome) this.openPopUpConfirmationEventListner();
  },
};
</script>
<style scoped>
.input-group,
.form-group {
  width: 100%;
  /*z-index: 12;*/
}
.section-home.page-header.page-header-smaller {
  min-height: 50vh;
  max-height: 440px;
}
.alert {
  position: fixed;
  width: 100%;
  z-index: 997;
  margin-top: 63px;
}
.alert-home-mobile {
  margin-top: 0px !important;
}
.full-background {
  height: 100vh;
}
@media screen and (max-width: 1024px) {
  .section-home.page-header.page-header-smaller {
    min-height: 30vh;
    max-height: 440px;
  }
}
</style>
